import React, { useEffect, useState } from 'react';
import classes from "./MatchLayoutNew.module.css";
import moment from "moment-timezone";
import { useNavigate } from 'react-router-dom';

const MatchLayoutNew = ({ match, index, fantasy_match_joined, prediction_match_joined }) => {
    const navigate = useNavigate();
    const [time, setTime] = useState(null);
    const [display, setDisplay] = useState("block");

    const matchTimer = (match_date_time) => {
        try {
            const liveTime = moment();
            const matchTime = moment.utc(match_date_time);
            const timeLeft = moment.duration(matchTime.diff(liveTime));

            if (timeLeft.asMilliseconds() <= 0) {
                console.log("Match has already started.");
                setDisplay("none");
            }
            const hours = Math.floor(timeLeft.asHours());
            const minutes = timeLeft.minutes();
            const seconds = timeLeft.seconds();

            console.log(`Match starts in ${hours}h ${minutes}m ${seconds}s`);
            setTime(`${hours}h ${minutes}m ${seconds}s`);
        } catch (error) {
            console.log(error, 'errro--');
        }
    }

    useEffect(() => {
        if (display !== "none") {
            const intervalId = setInterval(() => {
                matchTimer(match?.match_date_time);
            }, 1000);
            return () => clearInterval(intervalId);
        }
    }, [display]);

    return (
        <div
            className={classes.card}
            style={{ animationDelay: `${index * 0.07}s` }}
        >
            {/* League header */}
            <div className={classes.cardHeader}>
                <span className={classes.leagueBadge}>🏆</span>
                <span className={classes.leagueName}>{match?.league_name}</span>
                {display !== "none" && time && (
                    <span className={classes.countdownPill}>
                        <span className={classes.countdownDot} />
                        {time}
                    </span>
                )}
            </div>

            {/* Teams row */}
            <div className={classes.teamsRow}>
                {/* Home team */}
                <div className={classes.team}>
                    <div className={classes.logoWrap}>
                        <img
                            src={match?.home_team_image}
                            alt={match?.home_team_name}
                            className={classes.teamLogo}
                        />
                    </div>
                    <p className={classes.teamName}>{match?.home_team_name}</p>
                </div>

                {/* VS & time */}
                <div className={classes.vsBlock}>
                    <span className={classes.vsText}>VS</span>
                    <p className={classes.matchDate}>
                        {moment.utc(match?.match_date_time).local().format("ddd, DD MMM")}
                    </p>
                    <p className={classes.matchTime}>
                        {moment.utc(match?.match_date_time).local().format("hh:mm A")}
                    </p>
                </div>

                {/* Away team */}
                <div className={classes.team}>
                    <div className={classes.logoWrap}>
                        <img
                            src={match?.away_team_image}
                            alt={match?.away_team_name}
                            className={classes.teamLogo}
                        />
                    </div>
                    <p className={classes.teamName}>{match?.away_team_name}</p>
                </div>
            </div>

            {/* Action buttons */}
            <div className={classes.actionsRow}>
                {fantasy_match_joined ? (
                    <button
                        type="button"
                        className={`${classes.btn} ${classes.btnFantasy} ${classes.btnJoined}`}
                        onClick={() => navigate("/fantasy-game", {
                            state: { match_fixture_id: match?.match_fixture_id }
                        })}
                    >
                        <span className={classes.btnIcon}>⚽</span>
                        Check Fantasy Team
                        <span className={classes.joinedBadge}>✓ Joined</span>
                    </button>
                ) : (
                    <button
                        type="button"
                        className={`${classes.btn} ${classes.btnFantasy}`}
                        onClick={() => navigate("/create-fantasy-team", {
                            state: { match_fixture_id: match?.match_fixture_id }
                        })}
                    >
                        <span className={classes.btnIcon}>⚽</span>
                        Fantasy Team
                    </button>
                )}

                {prediction_match_joined ? (
                    <button
                        type="button"
                        className={`${classes.btn} ${classes.btnPredict} ${classes.btnJoined}`}
                        onClick={() => navigate("/prediction-game", {
                            state: { match_fixture_id: match?.match_fixture_id }
                        })}
                    >
                        <span className={classes.btnIcon}>🎯</span>
                        Joined Predict & Win
                        <span className={classes.joinedBadge}>✓</span>
                    </button>
                ) : (
                    <button
                        type="button"
                        className={`${classes.btn} ${classes.btnPredict}`}
                        onClick={() => navigate("/create-prediction", {
                            state: { match_fixture_id: match?.match_fixture_id }
                        })}
                    >
                        <span className={classes.btnIcon}>🎯</span>
                        Predict & Win
                    </button>
                )}
            </div>
        </div>
    );
}

export default MatchLayoutNew;